import { Card, CardProps } from "antd";
import { CreateArrearModal } from "./CreateArrearModal";
import React, { PropsWithChildren } from "react";
import ArrearsTable from "./ArrearsTable";

export const ArrearsTableCard = ({ cardProps, children }: { cardProps?: CardProps } & PropsWithChildren) => {
  return (
    <Card
      title={"Arretrati"}
      extra={<CreateArrearModal />}
      {...cardProps}
    >
      <ArrearsTable/>
    </Card>
  );
};